import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTheme } from "@/lib/theme";

/**
 * O componente que o shadcn gera lê o tema de `next-themes`, que é do
 * ecossistema Next — este painel é Vite e tem o próprio provider. Trocado
 * por `useTheme`, senão o toast escolheria o tema sozinho e apareceria claro
 * dentro do painel escuro.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { isDark } = useTheme();
  // No CELULAR o toast desce do topo; no desktop continua no canto inferior
  // direito.
  //
  // Embaixo ele caía EM CIMA da tab bar: medido num telefone de 390x844, o
  // toast ocupava 775–828 e a barra começa em 780 — 48 dos 54px do aviso
  // cobrindo Início/Agenda/Clientes/Ajustes. Some a navegação inteira por
  // alguns segundos, e o "×" de fechar ainda fica na borda esquerda da tela,
  // longe do polegar.
  //
  // Em cima não há esse conflito: o cabeçalho tem 56px e é informativo, não
  // navegação — e é de onde vêm os avisos no iOS e no Android, então o gesto
  // de dispensar (arrastar pra cima) é o que a pessoa já espera.
  const isMobile = useIsMobile();

  return (
    <Sonner
      theme={isDark ? "dark" : "light"}
      position={isMobile ? "top-center" : "bottom-right"}
      // Encosta logo abaixo do cabeçalho de 56px em vez de sobrepor o título.
      mobileOffset={{ top: "64px", left: "16px", right: "16px" }}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
